// extracted by mini-css-extract-plugin
module.exports = {"gift_divider":"styles_gift_divider__3Pdpe","gift_cards_wrapper":"styles_gift_cards_wrapper__1qsvG","day":"styles_day__Q_dHE","gift":"styles_gift__275yM","ava":"styles_ava__WNZLs"};